import React, { useEffect, useState } from "react";
import { fetchReportResources } from "../../../services/httpClient";
import { formatDateTimeToLocal } from "../../../helpers/date";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface ResourcesAssignedTableState {
  data?: any[];
  startDate?: string;
  endDate?: string;
  useDatePicker?: boolean;
  resourceType?: string;
}

export const ResourcesAssignedByTypeTable = ({
  data,
  startDate,
  endDate,
  useDatePicker = false,
  resourceType,
}: ResourcesAssignedTableState) => {
  const [resourceData, setResourceData] = useState<any[]>();

  const tableHeaders = [
    { label: "Resource ID", key: "resource_id", hide: true },
    { label: "Resource", key: "resource_name" },
    { label: "Category", key: "resource_category" },
    { label: "Quantity", key: "quantity" },
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name", hide: true },
    { label: "Name", key: "assignee_name" },
    { label: "Date", key: "assigned_at_formatted" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        setResourceData(data as any[]);
      } else {
        const starting = new Date();
        starting.setDate(starting.getDate() - 365);
        let start = starting.toISOString().slice(0, 10);
        let end = new Date().toISOString().slice(0, 10);
        if (useDatePicker) {
          start = startDate ?? start;
          end = endDate ?? end;
        }
        await getResourceData(start!, end!);
      }
    };
    fetchData();
  }, [data, startDate, endDate, useDatePicker]);

  const shapeData = (resources: any[]) => {
    const data = resources.filter((r) => r.resource_type_key === resourceType);

    const grouped = data.reduce(
      (acc, item) => {
        const key = `${item.assigned_at}-${item.resource_id}-${item.assignee_id}`;
        const localDateTime = formatDateTimeToLocal(item.assigned_at);

        if (!acc[key]) {
          acc[key] = {
            ...item,
            assigned_at_formatted: localDateTime.date,
            quantity: 0,
          };
        }

        acc[key].quantity += 1;

        return acc;
      },
      {} as Record<string, any>,
    );

    return Object.values(grouped).sort((a: any, b: any) => new Date(b.assigned_at).getTime() - new Date(a.assigned_at).getTime());
  };

  const getResourceData = async (start: string, end: string) => {
    await fetchReportResources(start, end)
      .then((res: any) => {
        const resources = res[0].data;
        setResourceData(shapeData(resources));
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return resourceData ? (
    <DataTable
      tableHeadings={tableHeaders}
      tableData={resourceData}
      title={resourceType === "consumable" ? "Consumables Assigned" : "Non-Consumables Assigned"}
    />
  ) : (
    loadingCard()
  );
};
